import { UserManager } from 'oidc-client'

// 使用id4更改这里1
class ApplicationUserManager extends UserManager {
  constructor () {
    super({
      authority: 'https://ids.cubicjoy.com',
      client_id: 'cbjgameadminjs',
      redirect_uri: 'https://vueadmin.cubicjoy.com/callback',
      response_type: 'id_token token',
      scope: 'openid profile roles cbjgame.core.api',
      post_logout_redirect_uri: 'https://vueadmin.cubicjoy.com'
    })
  }

  async login () {
    await this.signinRedirect()
    return this.getUser()
  }

  async logout () {
    return this.signoutRedirect()
  }
}

const applicationUserManager = new ApplicationUserManager()
export { applicationUserManager as default }
